export const fields = [
  {
    key: 'name',
    name: 'name',
    label: 'Nama Template',
    placeholder: 'Nama Template',
    type: 'text',
    validation: 'bail|required|max:255,length',
  },
  {
    key: 'description',
    name: 'description',
    label: 'Deskripsi',
    placeholder: 'Deskripsi',
    type: 'text',
    validation: 'bail|max:255,length',
  },
]
